// Fatia S1: como funciona (conexões oficiais, segurança, dinheiro dos anúncios, piloto com limites). Visual da home (home.css).
import { Link } from 'react-router-dom'
import { Bot, KeyRound, Lock, PiggyBank, Plug, ShieldCheck, Undo2 } from 'lucide-react'
import { Bullets, FeatureCard, FinalCta, Section } from '../../features/public/Site'
import { Reveal, Words } from '../../features/public/motion'

export default function HowItWorks() {
  return (
    <div className="sh">
      <Section hero>
        <Words as="h1" immediate className="sh-display sh-h1" text="Como o Seu Impulso *funciona.*" />
        <Reveal as="p" delay={300} className="sh-lead">Transparente do começo ao fim: o que lemos, o que fazemos e o que nunca fazemos.</Reveal>
      </Section>
      <Section alt>
        <div className="sh-split">
          <div>
            <Plug size={20} className="sh-card-ic" aria-hidden />
            <Words className="sh-display sh-h2" text="Conexões oficiais com as *plataformas de anúncio.*" />
            <p className="sh-p">Você entra pelas telas oficiais de cada plataforma e escolhe o que liberar. Nunca pedimos sua senha dessas plataformas.</p>
          </div>
          <div className="card">
            <Bullets items={[
              'Google Ads: campanhas, anúncios, buscas e resultados',
              'Meta (Instagram e Facebook): conta de anúncios, Página do Facebook e Pixel',
              'TikTok: conta de anunciante, campanhas e resultados',
              'OpenAI Ads (anúncios no ChatGPT): conta de anúncios, campanhas e resultados, por chave de API que você cria',
              'Mudanças nas campanhas só com a sua confirmação, ou dentro dos limites que você definir no piloto automático',
              'Desconecte quando quiser, aqui ou nas configurações de cada plataforma',
            ]} />
          </div>
        </div>
      </Section>
      <Section>
        <div className="sh-split">
          <div>
            <Words className="sh-display sh-h2" text="Você no controle do *quanto gasta.*" />
            <p className="sh-p">O orçamento mensal que você define vira um teto. Nenhuma ação do Seu Impulso passa desse valor.</p>
          </div>
          <div className="card">
            <PiggyBank size={20} className="sh-card-ic" aria-hidden />
            <h3 className="sh-card-title mt-12">O dinheiro dos anúncios não passa por nós</h3>
            <p className="muted mt-8">Você continua pagando as plataformas direto, com o cartão ou boleto que já usa lá. O Seu Impulso cobra só a assinatura. Não revendemos mídia e não seguramos o seu dinheiro.</p>
          </div>
        </div>
      </Section>
      <Section alt>
        <Bot size={20} className="sh-card-ic" aria-hidden />
        <Words className="sh-display sh-h2" text="Piloto automático com *limites que você define.*" />
        <div className="sh-grid3">
          <FeatureCard title="Só sugerir">O Seu Impulso mostra o que fazer e por quê. Você decide e aplica.</FeatureCard>
          <FeatureCard title="Copiloto">Ajustes pequenos ele faz sozinho; o que for maior pede a sua aprovação.</FeatureCard>
          <FeatureCard title="Automático">Age sozinho, sempre dentro dos limites de segurança.</FeatureCard>
        </div>
        <div className="card mt-16">
          <h3 className="sh-card-title">Limites que valem em qualquer modo</h3>
          <div className="mt-12"><Bullets items={['Teto mensal de investimento', 'Custo máximo por cliente', 'Variação máxima de orçamento por dia', 'Sempre pedir aprovação para aumentar o orçamento total', 'Não mexer em campanha que ainda está “aprendendo”']} /></div>
        </div>
        <div className="sh-line mt-16"><Undo2 size={18} aria-hidden /><span>Toda mudança fica no histórico (quem, quando, de → para) e pode ser desfeita.</span></div>
      </Section>
      <Section>
        <Words className="sh-display sh-h2" text="*Segurança.*" />
        <div className="sh-grid3">
          <FeatureCard icon={Lock} title="Tokens criptografados">As autorizações das plataformas são guardadas com criptografia forte e só são abertas no momento de usar.</FeatureCard>
          <FeatureCard icon={ShieldCheck} title="Cada empresa isolada">Os dados de uma empresa nunca aparecem para outra. Isso é garantido também no banco de dados.</FeatureCard>
          <FeatureCard icon={KeyRound} title="Verificação em duas etapas">Proteja seu login com o código do celular. Agências podem exigir isso de toda a equipe.</FeatureCard>
        </div>
        <p className="sh-fine">Detalhes sobre dados pessoais na <Link className="strong" to="/privacidade">política de privacidade</Link>.</p>
      </Section>
      <FinalCta />
    </div>
  )
}
